import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, share } from "rxjs/operators";
import { AngularFirestore, DocumentData } from "@angular/fire/compat/firestore";
import { where, query, average, collection, getAggregateFromServer, getCountFromServer, count, sum } from '@angular/fire/firestore';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' }) export class SalesReportService {

  queryPath;
  dataArySubs = new Subject();
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private afs: AngularFirestore, private http: HttpClient) {
  }

  getCompanies$() {
    return this.afs.collection('company').snapshotChanges().pipe(map(doc => {
      return doc.map(obj => {
        return {
          ...obj.payload.doc.data() as object,
          companyId: obj.payload.doc.id
        }
      })
    }))
  }

  getMappingByCompanyId() {
    // Sourced from system_info directly (the canonical System entity) rather
    // than machine_mapping — one doc per system, keyed by the real systemId,
    // so garantiomsetning/active/companyId/siteId are all read straight off
    // the same record edited via the System card/kort.
    return this.afs.collection('system_info').snapshotChanges()
      .pipe(map(data => {
        return data.map(doc => {
          const d = doc.payload.doc.data() as any;
          return {
            ...d,
            systemId: doc.payload.doc.id,
            // system_info's own `systemId` field is a human-typed label, not
            // the canonical id — kept here only for display (was
            // machine_mapping.localSystemId).
            localSystemId: d['systemId'] || doc.payload.doc.id,
            name: d['name'] || doc.payload.doc.id,
            systemName: d['name'] || doc.payload.doc.id,
            garantiomsetning: d['garantiomsetning'] ?? null,
            selected: false,
          };
        });
      })).pipe(map(data => {
        return data.sort((a, b) => (a.systemName || '').localeCompare(b.systemName || ''));
      }));
  }


  makeQuery(args) {
    let arr = []
    for (const arg in args) {

      if (arg == 'companyId')
        arr.push(where(arg, 'in', args[arg]));
      if (arg == 'systemId')
        arr.push(where(arg, 'in', args[arg]));
      if (arg == 'dateFrom')
        arr.push(where('unix', '>=', args[arg]));
      if (arg == 'categories')
        arr.push(where('categories', 'array-contains-any', args[arg]));


      if (arg == 'vat') {
        args[arg] != 'withoutvat' ? arr.push(where('mva', '==', Number(args[arg]))) : "";
      }

      if (arg == 'dateTo')
        arr.push(where('unix', '<=', args[arg]));
      // if (arg == 'isCreditActive') {
      //   if (args[arg] == false)
      //     arr.push(where('payType', '!=', 'credit'));
      // }


    }
    arr.push(where("status", "==", true));
    return arr;

  }

  getSalesRecord() {
    return this.afs.collection('salesRecord', ref => ref.where('salesCategory', '==', "perCompany").orderBy('unix', 'desc')).snapshotChanges().pipe(map(sp => {
      return sp.map(doc => {
        return {
          ...doc.payload.doc.data() as object,
          price: doc.payload.doc.data()[doc.payload.doc.data()['companyId'] + "_saleIncVAT"],
          priceWithoutMVA: doc.payload.doc.data()[doc.payload.doc.data()['companyId'] + "_saleWithoutVAT"],
          discountedPrice: doc.payload.doc.data()[doc.payload.doc.data()['companyId'] + "_salePriceDiscounted"],
          qty: doc.payload.doc.data()[doc.payload.doc.data()['companyId'] + "_quantity"],
          companyName: doc.payload.doc.data()['name'],
          day: moment.unix(doc.payload.doc.data()['unix'])
        }
      })
    }));


  }
  // async getSalesRapport(body) {
  //   let querySnapshot = await this.filterTransactions(body)
  //   let data = []
  //   querySnapshot.forEach(doc => {
  //     data.push(doc.data())
  //   })

  //   let newArry = await Promise.all(data.filter((value, index, self) => self.findIndex(i => i.productId === value.productId && i.systemId === value.systemId) === index)
  //     .map(async obj => {
  //       let filteredArray = data.filter(transaction => transaction.productId === obj.productId && transaction.systemId === obj.systemId);
  //       let filteredArrayQty = filteredArray.map(transaction => transaction.quantity);
  //       let filteredArraydiscountedPrices = filteredArray.map(transaction => transaction.discountedPrice);

  //       // console.log("filteredArray", JSON.stringify(filteredArray));
  //       // let productSnapShot = await this.getProductById(body, obj.productId)
  //       // console.log("productRef is received")
  //       let discountedPrice = filteredArraydiscountedPrices.reduce((acc, currValue) => {
  //         // console.log(acc, currValue)
  //         return Number(acc) + Number(currValue)
  //       }, 0);

  //       let quantity = filteredArrayQty.reduce((acc, currValue) => {
  //         return Number(acc) + Number(currValue)
  //       }, 0);
  //       // console.log("filteredArray", filteredArray)
  //       obj.qty = quantity;
  //       obj.discountedPrice = discountedPrice;
  //       obj.price = (obj.price) * quantity
  //       return obj;
  //     }))
  //   return newArry;
  // }



  async getSalesRapportByGraphForAllSelectedSystems(body) {
    
    return new Promise((res, rej) => {
      let queryArray = [];
      let queryPromise = [];
      let args = this.makeQuery(body);

      const transactionCollection = collection(this.afs.firestore, 'transactions')// collection of users

      body.systemsByCompany.forEach(element => {
        queryArray.push({ name: element.systemId, query: query(transactionCollection, where('systemId', '==', element.systemId), ...args) })

        // queryArray.push(query(transactionCollection,, ...args))
      });


      // let q = query(transactionCollection, ...args)
      if (body['vat'] == "withoutvat")
        queryArray.forEach((arg) => {
          queryPromise.push(getAggregateFromServer(arg.query, {
            income: sum('salepriceWithoutMVA'),
            count: count()

          }))
        })
      else {
        queryArray.forEach((arg) => {
          queryPromise.push(getAggregateFromServer(arg.query, {
            income: sum('price'),
            count: count()
          }))
        })
      }

      const promises = queryPromise.map(obj => obj);

      Promise.all(promises).then(d => {

        const result = queryArray.map((obj, index) => ({
          ...obj,
          income: d[index].data().income.toFixed(2),
          count: d[index].data().count.toFixed(2),
          // count: obj.data().count 

          // Replacing promises with resolved values
        }));
        
        // d.forEach(q => {
        //   returnData.push({ name: q.query._query.filters[0].value.stringValue, income: q.data().income.toFixed(2), count: q.data().count })
        // }
        // )
        res(result)
      })
    })



    // let querySnapshot = await this.filterTransactions(body)
    // let data = []
    // querySnapshot.forEach(doc => {
    //   data.push(doc.data())
    // })

    // let newArry = await Promise.all(data.filter((value, index, self) => self.findIndex(i => i.systemId === value.systemId) === index)
    //   .map(async obj => {
    //     let filteredArray = data.filter(transaction =>  transaction.systemId === obj.systemId);
    //     let filteredArrayQty = filteredArray.map(transaction => transaction.quantity);
    //     let filteredArraydiscountedPrices = filteredArray.map(transaction => transaction.discountedPrice);

    //     console.log("filteredArray", JSON.stringify(filteredArray));
    //     // let productSnapShot = await this.getProductById(body, obj.productId)
    //     // console.log("productRef is received")
    //     let discountedPrice = filteredArraydiscountedPrices.reduce((acc, currValue) => {
    //       // console.log(acc, currValue)
    //       return Number(acc) + Number(currValue)
    //     }, 0);

    //     let quantity = filteredArrayQty.reduce((acc, currValue) => {
    //       return Number(acc) + Number(currValue)
    //     }, 0);
    //     // console.log("filteredArray", filteredArray)
    //     obj.qty = quantity;
    //     obj.discountedPrice = discountedPrice;
    //     obj.price = (obj.price) * quantity
    //     return obj;
    //   }))
    // return newArry;
  }

  async getSalesRapportByGraphForSelectedCategories(body) {
    return new Promise((res, rej) => {
      let queryArray = [];
      let queryPromise = [];
      let returnData = [];
      let args = this.makeQuery(body);

      const transactionCollection = collection(this.afs.firestore, 'transactions')// collection of users

      body.systemsByCompany.forEach(element => {
        body.categories.forEach(category => {
          queryArray.push({ category: category, name: element.systemId, query: query(transactionCollection, where('systemId', '==', element.systemId), where('categories', 'array-contains-any', [category]), ...args) })
        });
      });

      if (body['vat'] == "withoutvat")
        queryArray.forEach((arg) => {
          queryPromise.push(getAggregateFromServer(arg.query, {
            income: sum('salepriceWithoutMVA'),
            count: count()

          }))
        })
      else {
        queryArray.forEach((arg) => {
          queryPromise.push(getAggregateFromServer(arg.query, {
            income: sum('price'),
            count: count()
          }))
        })
      }

      const promises = queryPromise.map(obj => obj);

      Promise.all(promises).then(d => {

        const result = queryArray.map((obj, index) => ({
          name: obj.name,
          category: obj.category,
          income: d[index].data().income.toFixed(2),
          count: d[index].data().count.toFixed(2),
        }));
        res(result)
      })
    })

  }

  async getTransactionSale(body) {
    
    let args = this.makeQuery(body);
    let s = sum('price');
    let sub = sum('discountedPrice');
    if (body['vat'] == "withoutvat") {
      s = sum('salepriceWithoutMVA')
    }
    else {
      s = sum('price')
    }
    const transactionCollection = collection(this.afs.firestore, 'transactions')// collection of users
    let q = query(transactionCollection, ...args)

    const count = await getCountFromServer(q);
    // const sumQuery = await getAggregateFromServer(q, {
    //   income: sum('price'),
    // });
    const vippsQ = query(transactionCollection, ...args, where('payType', '==', 'vipps'))
    const vippsCount = await getCountFromServer(vippsQ);

    const vippsSumQuery = await getAggregateFromServer(vippsQ, {
      income: s,
      sub: sub
    });

    const stripeQ = query(transactionCollection, ...args, where('payType', '==', 'stripe'))
    const stripeCount = await getCountFromServer(stripeQ);

    const stripeSumQuery = await getAggregateFromServer(stripeQ, {
      income: s,
      sub: sub
    });
    const creditQ = query(transactionCollection, ...args, where('payType', '==', 'credit'))
    const creditCount = await getCountFromServer(creditQ);

    const creditSumQuery = await getAggregateFromServer(creditQ, {
      income: s,
    });


    if (body.withCredit) {
      const creditQ = query(transactionCollection, ...args, where('payType', '==', 'credit'))
      const creditCount = await getCountFromServer(creditQ);

      const creditSumQuery = await getAggregateFromServer(creditQ, {
        income: s,
      });

      return { creditCount: creditCount.data().count, creditIncome: creditSumQuery.data().income.toFixed(2) };
    }

    let result = {
      // totalIncome: sumQuery.data().income,
      totalCount: count.data().count,
      totalSubsidy: vippsSumQuery.data().income - vippsSumQuery.data().sub + stripeSumQuery.data().income - stripeSumQuery.data().sub,
      vippsIncome: vippsSumQuery.data().sub,
      vippsCount: vippsCount.data().count,
      stripeIncome: stripeSumQuery.data().sub,
      stripeCount: stripeCount.data().count,
      creditIncome: creditSumQuery.data().income,
      creditCount: creditCount.data().count
    }
    // console.log("sumQuery", result);

    return result;

  }
  myFilter(ref, key, operator, values) {
    if (values == true)
      return ref.where(key, operator, values)
    else if (values) {
      return values.length > 0 ? ref.where(key, operator, values) : ref;
    }
    else
      return ref;
  }


  myFilterUnix(ref, key, operator, value) {
    return value ? ref.where(key, operator, value) : ref;
  }



  filterTransactions(data) {
    let ref = this.afs.collection('transactions').ref;
    ref = this.myFilter(ref, `companyId`, `in`, data.companyId);
    ref = this.myFilter(ref, `systemId`, `in`, data.systemId);
    ref = this.myFilterUnix(ref, `unix`, `>=`, data.dateFrom);
    ref = this.myFilterUnix(ref, `unix`, `<=`, data.dateTo);

    ref = this.myFilter(ref, `status`, `==`, true);

    return ref.get();
  }

  getProductById = async (address, productId) => {
    return await this.afs.collection('company').doc(address.companyId).collection('products').doc(productId).get()
  }

  getListSalesReport(body) {

    body = JSON.stringify(body);
    body = JSON.parse(body)
    return this.http.post(environment.apiUrl + "/widgets/reportgeneratbySystem", JSON.stringify(body), this.httpOptions).pipe(map(res => {
      if (Array.isArray(res)) {
        return res
      } else {
        return null
      }
    })).pipe(share());;
  }

  getProductSalesReport(body) {

    body = JSON.stringify(body);
    body = JSON.parse(body)
    return this.http.post(environment.apiUrl + "/widgets/salesreportgeneratorbyprodcut", JSON.stringify(body), this.httpOptions).pipe(map(res => {
      if (Array.isArray(res)) {
        return res
      } else {
        return null
      }
    })).pipe(share());;
  }

  // makecompanysalereport(body) {
  //   body = JSON.stringify(body);
  //   body = JSON.parse(body)
  //   this.http.post(environment.apiUrl + "/widgets/makecompanysalereport", JSON.stringify(body), this.httpOptions).subscribe(doc => {
  //     console.log(doc)
  //   })
  // }




  async getTimeIntervals(body, startTime, endTime, type) {
    const MS_PER_HOUR = 60 * 60 * 1000;
    const MS_PER_DAY = 24 * MS_PER_HOUR;
    const MS_PER_WEEK = 7 * MS_PER_DAY;
    const MS_PER_MONTH = 31 * MS_PER_DAY + MS_PER_DAY; // Approximate month length
    const MS_PER_YEAR = 365 * MS_PER_DAY; // Approximate year length


    let intervals = [];
    let currentDate: any = new Date(startTime * 1000);
    let endDate: any = new Date(endTime * 1000);
    let duration = endDate - currentDate;

    const mockServerCall = async (interval) => {
      // Simulate a server call with a delay
      return new Promise((res, rej) => {

        body.dateFrom = interval.startUnix;
        body.dateTo = interval.endUnix;
        this.http.post(environment.apiUrl + "/widgets/getsalebytime", JSON.stringify(body), this.httpOptions).toPromise()

          .then(doc => {
            res(doc);
          }) // Simulate network delay
        // Example server response
      })


    };

    const ServerCallSvinn = async (interval) => {
      // Simulate a server call with a delay
      return new Promise((res, rej) => {

        body.dateFrom = interval.startUnix;
        body.dateTo = interval.endUnix;
        this.http.post(environment.apiUrl + "/widgets/svinnreportforsale", JSON.stringify(body), this.httpOptions).toPromise()

          .then(doc => {
            res(doc);
          }) // Simulate network delay
      })


    };

    const createIntervalObject = (formatted, startUnix, endUnix) => {
      return {
        formatted: formatted,
        startUnix: startUnix,
        endUnix: endUnix,
        body,
        fetchServerData: async function () {
          this.serverData = type != "SVINN" ? await mockServerCall(this) : await ServerCallSvinn(this);
          return this;
        }
      };
    };

    if (duration <= MS_PER_DAY) {
      while (currentDate <= endDate) {
        let intervalStart = Math.floor(currentDate.getTime() / 1000);
        let nextDate = new Date(currentDate.getTime() + MS_PER_HOUR);
        let intervalEnd = Math.min(Math.floor(nextDate.getTime() / 1000), endTime);
        let formatted = currentDate.toLocaleTimeString('en-US', { hour: '2-digit', hour12: false, });
        intervals.push(createIntervalObject(formatted, intervalStart, intervalEnd));
        currentDate = nextDate;
      }
    } else if (duration <= MS_PER_WEEK) {
      // Daily intervals with week days
      while (currentDate <= endDate) {
        let intervalStart = Math.floor(currentDate.getTime() / 1000);
        let nextDate = new Date(currentDate);
        nextDate.setDate(currentDate.getDate() + 1);
        let intervalEnd = Math.min(Math.floor(nextDate.getTime() / 1000), endTime);
        let formatted = currentDate.toLocaleDateString('en-US', { weekday: 'long' });
        intervals.push(createIntervalObject(formatted, intervalStart, intervalEnd));
        currentDate = nextDate;
      }
    } else if (duration <= MS_PER_MONTH) {
      while (currentDate <= endDate) {
        let intervalStart = Math.floor(currentDate.getTime() / 1000);
        let nextDate = new Date(currentDate);
        nextDate.setDate(currentDate.getDate() + 1);
        let intervalEnd = Math.min(Math.floor(nextDate.getTime() / 1000), endTime);
        let formatted = currentDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
        intervals.push(createIntervalObject(formatted, intervalStart, intervalEnd));
        currentDate = nextDate;
      }
    } else if (duration <= MS_PER_YEAR) {

      while (currentDate <= endDate) {
        let intervalStart = Math.floor(currentDate.getTime() / 1000);
        let nextDate = new Date(currentDate);
        nextDate.setMonth(currentDate.getMonth() + 1);
        let intervalEnd = Math.min(Math.floor(nextDate.getTime() / 1000), endTime);
        let formatted = currentDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
        intervals.push(createIntervalObject(formatted, intervalStart, intervalEnd));
        currentDate = nextDate;
      }
    } else {
      while (currentDate <= endDate) {
        let intervalStart = Math.floor(currentDate.getTime() / 1000);
        let nextDate = new Date(currentDate);
        nextDate.setFullYear(currentDate.getFullYear() + 1);
        let intervalEnd = Math.min(Math.floor(nextDate.getTime() / 1000), endTime);
        let formatted = currentDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
        intervals.push(createIntervalObject(formatted, intervalStart, intervalEnd));
        currentDate = nextDate;
      }
    }

    // Fetch data from server for each interval
    const fetchAllData = intervals.map(interval => interval.fetchServerData());
    await Promise.all(fetchAllData);

    return intervals;
  }
}